<template lang="pug">
vm-prompt(
  @vm-cancel="close",
  @vm-accept="saveRecord",
  @vm-close="close",
  :vm-accept-text="$t('strings.accept')",
  :vm-cancel-text="$t('strings.cancel')",
  :vm-active="isModalRevisionVisible",
  :vm-is-valid="!$v.revision.$invalid",
  :vm-title="getTitle"
)
  vm-row(
    vm-align="center",
    vm-type="flex",
    vm-justify="space-between",
    vm-w="12"
  )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(
          :placeholder="$t('revisions.package_name_placeholder')",
          :danger="$v.revision.package_name.$invalid && $v.revision.package_name.$model",
          :danger-text="$t('validation.required', { attribute: $t('revisions.package_name') })",
          v-model="revision.package_name",
          :label="$t('revisions.package_name')"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-date-picker(
          style="width: 100%",
          :label="isQuote ? $t('projects.recept_date') : $t('revisions.starting_date')",
          :danger="$v.revision.starting_date.$invalid && $v.revision.starting_date.$model",
          :danger-text="$t('validation.required')",
          v-model="revision.starting_date"
        )
    vm-col(v-if="!isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-date-picker(
          v-if="!isAdd",
          style="width: 100%",
          :label="$t('revisions.end_date')",
          v-model="revision.end_date"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-select(
          :label="$t('revisions.type')",
          v-model="revision.type",
          :danger="$v.revision.type.$invalid && $v.revision.type.$model",
          :placeholder="$t('revisions.type_placeholder')"
        )
          vm-select-item(:value="1", text="Quotation")
          vm-select-item(:value="4", text="Drawings")
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        input(
          type="file",
          ref="file",
          v-on:change="handleFileUpload()",
          accept="application/pdf"
        )
    vm-col(v-if="isAdd", vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-textarea(
          :placeholder="$t('revisions.comments_placeholder')",
          v-model="revision.comments",
          :label="$t('revisions.comments')"
        )
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalRevision',
  props: {
    revision: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      default: false,
      type: Boolean
    },
    isQuote: {
      default: false,
      type: Boolean
    },
    customer: {
      default: false,
      type: Boolean
    }
  },
  validations () {
    return {
      revision: {
        package_name: {
          required
        },
        starting_date: {
          required
        },
        end_date: {
          required: requiredIf(function () {
            return !this.isAdd
          })
        },
        type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalRevisionVisible', 'inOrder']),
    getTitle () {
      return this.isAdd ? this.$t('revisions.add') : this.$t('revisions.edit')
    }
  },
  methods: {
    ...mapActions([
      'setModalRevisionVisible',
      'addRevision',
      'editRevision',
      'setLoading'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      this.setLoading(true)
      if (this.isAdd) {
        await this.addRevision({
          revision: this.revision,
          project: this.inOrder,
          file: this.file
        })
      } else {
        await this.editRevision({
          revision: this.revision,
          project: this.inOrder
        })
      }
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalRevisionVisible(false)
    }
  }
}
</script>
